module.exports = __webpack_public_path__ + "static/img/mine_agreement@3x.0899ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_agreement@3x.png
// module id = msTP
// module chunks = 1